const dataLayerProvider = {};

dataLayerProvider.inject = (data) => {
  if (!data) {
    console.error('Data not found, please provide an object for dataLayer.');
    return;
  }

  if (typeof dataLayer !== 'undefined') {
    dataLayer.splice(1, 0, data);
  } else {
    console.log('dataLayer not found in global object.');
  }
};

export default dataLayerProvider;